<template>
  <div class="order-list-page">
    <!-- 订单状态标签 -->
    <div class="order-tabs">
      <div
        v-for="tab in tabs"
        :key="tab.value"
        class="tab-item"
        :class="{ active: activeTab === tab.value }"
        @click="selectTab(tab.value)"
      >
        {{ tab.label }}
      </div>
    </div>

    <!-- 订单列表 -->
    <div class="order-list-container">
      <div v-if="orders.length > 0" class="orders-list">
        <order-card
          v-for="order in orders"
          :key="order.id"
          :order="order"
          @click="goToOrderDetail"
        />
      </div>
      <empty-state
        v-else
        title="暂无订单"
        description="您还没有任何订单"
        emoji="📋"
        :show-button="true"
        button-text="去浏览产品"
        @click="goToProductList"
      />
    </div>

    <!-- 加载更多 -->
    <div v-if="hasMore && orders.length > 0" class="load-more">
      <button v-if="!loading" class="load-more-btn" @click="loadMore">
        加载更多
      </button>
      <div v-else class="loading-text">加载中...</div>
    </div>
  </div>
</template>

<script>
import { getOrderList } from '@/api/order'
import OrderCard from '@/components/order-card/order-card.vue'
import EmptyState from '@/components/empty-state/empty-state.vue'

export default {
  name: 'OrderList',
  components: {
    OrderCard,
    EmptyState
  },
  data() {
    return {
      tabs: [
        { label: '全部', value: '' },
        { label: '待支付', value: '0' },
        { label: '待出行', value: '1' },
        { label: '已完成', value: '4' },
        { label: '已取消', value: '5' }
      ],
      activeTab: '',
      orders: [],
      pageIndex: 1,
      pageSize: 20,
      hasMore: true,
      loading: false
    }
  },
  mounted() {
    this.loadOrders()
  },
  methods: {
    selectTab(status) {
      this.activeTab = status
      this.pageIndex = 1
      this.hasMore = true
      this.orders = []
      this.loadOrders()
    },
    async loadOrders() {
      if (this.loading) return

      this.loading = true
      try {
        const res = await getOrderList({
          status: this.activeTab || undefined,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        })

        if (this.pageIndex === 1) {
          this.orders = res.data || []
        } else {
          this.orders.push(...(res.data || []))
        }

        this.hasMore = (res.data || []).length >= this.pageSize
      } catch (error) {
        console.error('加载订单列表失败:', error)
        this.$alert('加载失败，请重试')
      } finally {
        this.loading = false
      }
    },
    loadMore() {
      this.pageIndex++
      this.loadOrders()
    },
    goToOrderDetail(order) {
      this.$router.push({
        name: 'OrderDetail',
        params: { id: order.id }
      })
    },
    goToProductList() {
      this.$router.push('/products')
    }
  }
}
</script>

<style lang="scss" scoped>
.order-list-page {
  width: 100%;
  min-height: 100vh;
  background: #f9fafb;
}

.order-tabs {
  display: flex;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 10;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}

.tab-item {
  flex: 1;
  padding: 12px 16px;
  font-size: 14px;
  color: #6b7280;
  border-bottom: 2px solid transparent;
  text-align: center;
  white-space: nowrap;
  transition: all 0.3s ease;

  &.active {
    color: #ff720d;
    border-bottom-color: #ff720d;
  }
}

.order-list-container {
  padding: 12px 0;
}

.orders-list {
  padding: 12px;
}

.load-more {
  padding: 20px 16px;
  text-align: center;
}

.load-more-btn {
  width: 100%;
  max-width: 200px;
  padding: 10px 20px;
  background: linear-gradient(90deg, #ffa43a 0%, #ff720d 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:active {
    opacity: 0.8;
  }
}

.loading-text {
  font-size: 14px;
  color: #6b7280;
}
</style>
